import type { MapIcon } from 'features/mapping/mapping.types';

export const DiagonalHatchPatternBlack: MapIcon = {
  name: 'DiagonalHatchPatternBlack',
  width: 5,
  height: 5,
  data: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10'%3E%3Cpath d='M-1,1 l2,-2 M0,10 l10,-10 M9,11 l2,-2' stroke='black' stroke-width='3'/%3E%3C/svg%3E",
  skipRerenderOnPixelRatioChange: true,
};

export const DiagonalHatchPatternWhite: MapIcon = {
  name: 'DiagonalHatchPatternWhite',
  width: 5,
  height: 5,
  data: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10'%3E%3Cpath d='M-1,1 l2,-2 M0,10 l10,-10 M9,11 l2,-2' stroke='white' stroke-width='3'/%3E%3C/svg%3E",
  skipRerenderOnPixelRatioChange: true,
};

export const CrossHatchPatternBlack: MapIcon = {
  name: 'CrossHatchPatternBlack',
  width: 15,
  height: 15,
  data: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30'%3E%3Cpath d='M-1,1 l2,-2 M0,30 l30,-30 M29,31 l2,-2 M-1,29 l2,2 M0,0 l30,30 M29,-1 l2,2' stroke='black' stroke-width='2'/%3E%3C/svg%3E",
  skipRerenderOnPixelRatioChange: true,
};

export const SelectedPolygonPattern: MapIcon = {
  name: 'SelectedPolygonPattern',
  width: 32,
  height: 32,
  data: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgdmlld0JveD0iMCAwIDEyOCAxMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8xMDc5Ml8yMzM2MjEpIj4KPHJlY3QgeD0iOTYuMDM3NCIgeT0iLTUwLjg1NDUiIHdpZHRoPSIzIiBoZWlnaHQ9IjIyNCIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgOTYuMDM3NCAtNTAuODU0NSkiIGZpbGw9IiM1MkU4RUIiLz4KPHJlY3QgeD0iOTYiIHk9Ii03NyIgd2lkdGg9IjMiIGhlaWdodD0iMjI0IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSA5NiAtNzcpIiBmaWxsPSIjNTJFOEVCIi8+CjxyZWN0IHg9IjEwNy4zNTEiIHk9Ii0zOC41NDEiIHdpZHRoPSIzIiBoZWlnaHQ9IjIyNCIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMTA3LjM1MSAtMzguNTQxKSIgZmlsbD0iIzUyRThFQiIvPgo8cmVjdCB4PSIxMTguNjY1IiB5PSItMjUuMjI3MSIgd2lkdGg9IjMiIGhlaWdodD0iMjI0IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAxMTguNjY1IC0yNS4yMjcxKSIgZmlsbD0iIzUyRThFQiIvPgo8cmVjdCB4PSIxMzguOTc5IiB5PSItMTguOTEzNiIgd2lkdGg9IjMiIGhlaWdodD0iMjI0IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAxMzguOTc5IC0xOC45MTM2KSIgZmlsbD0iIzUyRThFQiIvPgo8cmVjdCB4PSIxNDQuMjkyIiB5PSIyLjQwMDM5IiB3aWR0aD0iMyIgaGVpZ2h0PSIyMjQiIHRyYW5zZm9ybT0icm90YXRlKDQ1IDE0NC4yOTIgMi40MDAzOSkiIGZpbGw9IiM1MkU4RUIiLz4KPHJlY3QgeD0iMTUyLjYwNiIgeT0iMjAuNzEzOSIgd2lkdGg9IjMiIGhlaWdodD0iMjI0IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAxNTIuNjA2IDIwLjcxMzkpIiBmaWxsPSIjNTJFOEVCIi8+CjxyZWN0IHg9IjIwMi4zOTIiIHk9IjE5IiB3aWR0aD0iMyIgaGVpZ2h0PSIyMjQiIHRyYW5zZm9ybT0icm90YXRlKDQ1IDIwMi4zOTIgMTkpIiBmaWxsPSIjNTJFOEVCIi8+CjxyZWN0IHg9IjIwMi41IiB5PSI0NiIgd2lkdGg9IjMiIGhlaWdodD0iMjI0IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAyMDIuNSA0NikiIGZpbGw9IiM1MkU4RUIiLz4KPHJlY3QgeD0iMTY3LjIzMyIgeT0iMjkuMzQxMyIgd2lkdGg9IjMiIGhlaWdodD0iMjI0IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAxNjcuMjMzIDI5LjM0MTMpIiBmaWxsPSIjNTJFOEVCIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTA3OTJfMjMzNjIxIj4KPHJlY3Qgd2lkdGg9IjEyOCIgaGVpZ2h0PSIxMjgiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==',
  skipRerenderOnPixelRatioChange: true,
};

/** Icons to register as map images. */
export const patternIcons: MapIcon[] = [
  DiagonalHatchPatternBlack,
  DiagonalHatchPatternWhite,
  CrossHatchPatternBlack,
  SelectedPolygonPattern,
];
